import React from 'react';
import './styles/ProductsGrid.scss';
import { ProductUI } from '../types';
import { ThemeLoader } from './ThemeLoader';
import { ProductCard } from './ProductCard';

interface ProductsGridProps {
  products: ProductUI[];
  onProductClick: (product: ProductUI) => void;
  isLoading: boolean;
}

export const ProductsGrid: React.FC<ProductsGridProps> = ({
  products,
  onProductClick,
  isLoading
}) => {
  if (isLoading) {
    return (
      <div className="products-grid">
        <div className="products-grid__loading">
          <ThemeLoader />
        </div>
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="products-grid__empty">
        <p>Товары не найдены</p>
      </div>
    );
  }

  return (
    <div className="products-grid">
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
          onClick={() => onProductClick(product)}
        />
      ))}
    </div>
  );
};
